import { render } from "./FavoriteMexc.vue?vue&type=template&id=65bf82ed"
import script from "./FavoriteMexc.vue?vue&type=script&lang=js"
export * from "./FavoriteMexc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__